<template>
  <CustomModal ref="modal" title="Retirer une option">
    <p v-if="option">Retirer l'option <strong>{{ option.title }}</strong> du groupe <strong>{{ group.name }}</strong> ?</p>
    <p>Les utilisateurs du groupe perdront l'accès au module correspondant à leur prochaine connexion. Les données déjà saisies sont conservées : l'option peut être ajoutée de nouveau à tout moment.</p>
    <div class="button-container">
      <CustomForm ref="form" :inputs=[] :submit=buttons.submit>
        <CustomButton @click="submitForm" :params=buttons.submit />
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import CustomForm from "@/components/forms/CustomForm.vue";
import {NotificationService} from "@vues/v-common";
import {AdministrationController} from "@/administration/controllers/AdministrationController";

export default {
  name: 'RemoveGroupOptionModal',
  props: ['callback'],
  components: {CustomForm, CustomModal, CustomButton},
  data() {
    return {
      group: undefined,
      option: undefined,
      buttons: {
        submit: {text: "Retirer"},
      },
    };
  },
  methods: {
    openModal(group, option) {
      this.group = group;
      this.option = option;
      this.$refs.modal.openModal();
    },
    closeModal(event = false) {
      this.$refs.modal?.closeModal(event);
    },
    async submitForm() {
      const res = await this.$refs.form.submitForm(() => AdministrationController.removeOption(this.group.id, this.option.name));
      if (!res.errors) {
        (new NotificationService).addNotification("success", `Option « ${this.option.title} » retirée du groupe`);
        this.closeModal(true);
        this.callback();
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@require '~/src/common/style/common.styl';

p
  padding-left 40px
  padding-right 40px

.button-container
  display flex
  justify-content center
  padding 20px 0 40px

  form
    align-items center

    button
      width 150px
</style>
